// Canonical plan hash shared between backend and frontend
// Normalizes inputs and applies FNV-1a 32-bit over the canonical string
export function computePlanHash(input) {
    try {
        const normalize = (obj) => JSON.parse(JSON.stringify(obj, (_k, v) => (v === undefined ? null : v)));
        const payload = normalize({
            plan: input?.plan
                ? {
                    widgets: (input.plan.widgets || []).map((w) => ({
                        type: String(w.type || '')
                            .trim()
                            .replace(/[.,;:]+$/g, ''),
                        title: w.title || null,
                        position: w.position || null,
                        config: w.config || null,
                    })),
                    connections: input.plan.connections || [],
                }
                : null,
            dsl: input?.dsl || null,
        });
        const str = JSON.stringify(payload);
        // FNV-1a 32-bit
        let h = 2166136261;
        for (let i = 0; i < str.length; i++) {
            h ^= str.charCodeAt(i);
            h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
            h >>>= 0;
        }
        return h.toString(36);
    }
    catch {
        try {
            const s = String(input ?? '');
            let hash = 0;
            for (let i = 0; i < s.length; i++) {
                const chr = s.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0;
            }
            return (hash >>> 0).toString(36);
        }
        catch {
            return '0';
        }
    }
}
